import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    public stats: any[] = [];
    public recentItems: any[] = [];
    public loading: boolean = true;

    public links: any[] = [
        { url: 'https://solution.inspectpro.seasonai.net/main', icon: 'fa-solid fa-helmet-safety', label: 'M-Pro', color: 'bg-blue-600' },
        { url: 'https://portal.isri.co.kr/dashboard', icon: 'fa-solid fa-building-shield', label: 'F-Pro', color: 'bg-emerald-600' },
        { url: 'https://safety.inspectpro.seasonai.net/home', icon: 'fa-solid fa-magnifying-glass-chart', label: 'Inspect-Pro', color: 'bg-orange-500' },
        { url: 'https://safety.inspectpro.seasonai.net/checklist', icon: 'fa-solid fa-clipboard-check', label: 'CL-Pro', color: 'bg-violet-600' },
        { url: 'https://check.inspect.seasonai.net/chatbot', icon: 'fa-solid fa-robot', label: 'AutoCheck-Pro', color: 'bg-rose-600' },
        { url: 'http://pq.isri.co.kr', icon: 'fa-solid fa-chart-column', label: 'NicePQ-Pro', color: 'bg-cyan-600' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("overview");
        if (code === 200) {
            this.stats = data.stats || [];
            this.recentItems = data.recent || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public open(url: string) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}

export default PageDashboardComponent;